import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import appConnection from "../../../firebase";

export const auth = getAuth(appConnection);
export const db = getFirestore(appConnection);
export const storage = getStorage(appConnection);
